import { useCallback } from 'react'

import { defaultError } from 'common/mocks/ResponseError'
import NewRelicUtils from 'config/monitoring/NewRelicUtils'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'
import { ErrorDetails } from 'store/error/types'

export const useLocalErrorHandler = () => {
  const handlerError = useCallback(
    (error: Error, errorCodeRef: string, errorDetails?: ErrorDetails, restart?: boolean) => {
      NewRelicUtils.noticeError(error, { errorCodeRef })

      errorDetails ??= {
        ...defaultError,
        route: restart ? TypesRoutes.START : undefined,
      }

      useBoundState.getState().setHasError(errorDetails)
      useBoundState.getState().setIsLoading(false)
    },
    [],
  )

  return handlerError
}
